module.exports = __webpack_public_path__ + "static/media/dig-all.d2ae0a64.png";